import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";

import CustomTabs from "../../components/Tab";
import InputBox from "../../components/InputBox";
import SelectDropDown from "../../components/SelectDropDown";
import DupontDatePicker from "../../components/DatePopover/DupontDatePicker";
import { DatePickerConfig } from "../../components/DatePopover/DateTimeConfig";
import { TextFieldValidator } from "../../components/InputBox/TextFieldValidator";
import PopoverText from "../../components/PopoverText";
import InfoIconGreen from "../../assets/info-icon-green.svg";

import "./index.scss";

const RoConfiguration = ({
  trains,
  setTrains,
  setTotalNumberOfElements,
  setTotalNumberOfActiveArea,
  rackValidationSucessfull,
  setStageValidationSucessfull,
}) => {
  const { t, i18n } = useTranslation();
  const [trainobj, setTrainObj] = useState(trains);
  const [noOfTrains, setNoOfTrains] = useState(
    Object.keys(trains).length === 0 ? 1 : Object.keys(trains).length
  );
  const [train, setTrain] = useState(
    Object.keys(trains).length === 0 ? 1 : Object.keys(trains).length
  );
  const [traintabs, setTraintabs] = useState([]);
  const [selectedTrain, setSelectedTrain] = useState(0);
  const [selectedTrainPage, setSelectedTrainPage] = useState(null);

  useEffect(() => {
    if (trains && Object.keys(trains).length >= 1) {
      // setTrain(trains.length);
      //setNoOfTains(trains.length);
      setTrainObj(Object.values(trains));
    }
  }, [trains, t]);

  useEffect(() => {
    const tabs = [];
    if (train === "" || train === undefined || train === "0") {
      return;
    }

    if (trainobj.length > train) {
      for (let i = trainobj.length; i > train; i--) {
        trainobj.pop(i - 1);
      }
    }
    var start = trainobj === undefined ? 0 : Object.keys(trainobj).length;
    for (let i = start + 1; i <= parseInt(train); i++) {
      const newTrain = {
        train_id: i,
        racks: [{ rack_id: 1 }],
      };
      trainobj.push(newTrain);
    }

    for (let i = 1; i <= parseInt(train); i++) {
      tabs.push({
        label: `${t("addNewPlant.train")} ${i}`,
        tabval: `${t("addNewPlant.train")} ${i}`,
        page: (
          <StageComponent
            train_id={i}
            t={t}
            trains={trainobj}
            setTrains={setTrains}
            setTotalNumberOfElements={setTotalNumberOfElements}
            setTotalNumberOfActiveArea={setTotalNumberOfActiveArea}
            rackValidationSucessfull={rackValidationSucessfull}
            setStageValidationSucessfull={setStageValidationSucessfull}
          />
        ),
      });
    }
    setTrains({ ...trainobj });
    setTraintabs(tabs);
    if (tabs && tabs.length && tabs.length > selectedTrain) {
      setSelectedTrainPage(tabs[selectedTrain]?.page);
    } else {
      setSelectedTrain(0);
      setSelectedTrainPage(tabs[0]?.page);
    }
  }, [train, trainobj, rackValidationSucessfull, t]);
  const onTrainChanged = (value) => {
    const trainsNum =
      noOfTrains > 20 || noOfTrains === "" || noOfTrains === 0
        ? "0"
        : noOfTrains;
    setTrain(trainsNum);
  };

  const onTrainTabSelected = (value) => {
    setSelectedTrainPage(traintabs[value].page);
    setSelectedTrain(value);
  };

  return (
    <>
      <div className="flex-between outline-box">
        <span className="description-text">
          {t("addNewPlant.noOfTrains")}
          <span style={{ color: "red" }}> *</span>
        </span>
        <InputBox
          name="trains"
          value={noOfTrains}
          customClass="custom-input-width "
          placeholder={t("addNewPlant.noOfTrains")}
          onChange={(value) => setNoOfTrains(value)}
          blurHandler={onTrainChanged}
          validator={TextFieldValidator.NUMBER_ONLY}
          errorMsg={
            noOfTrains === "" || noOfTrains === "0" || noOfTrains > 20
              ? t("addNewPlant.trainsValidation")
              : ""
          }
        />
      </div>
      {traintabs && (
        <>
          <div className="horizontal-scroll-container">
            <div className="horizontal-scroll">
              <CustomTabs
                tabOptions={traintabs}
                tabChangeHandler={onTrainTabSelected}
                value={selectedTrain}
              />
            </div>
          </div>
          <div>{selectedTrainPage}</div>
        </>
      )}
    </>
  );
};

export default RoConfiguration;

const rackOptions = () => {
  return ["1", "2", "3", "4", "5"];
};

export const StageComponent = ({
  train_id,
  t,
  trains,
  setTrains,
  setTotalNumberOfElements,
  setTotalNumberOfActiveArea,
  rackValidationSucessfull,
  setStageValidationSucessfull,
}) => {
  train_id -= 1;
  const rackOption = rackOptions();
  const [rack, setRack] = useState(trains[train_id].racks.length);
  const [inputVal, setInputVal] = useState([]);
  const stageNo =
    trains[train_id]?.racks?.length <= 0 ? 1 : trains[train_id]?.racks?.length;

  useEffect(() => {
    if (Array.isArray(trains)) {
      setInputVal([...trains]);
      const totals = getTotalNumber(trains);
      setTotalNumberOfElements(totals.total_Modules);
      setTotalNumberOfActiveArea(totals.total_ActiveArea);
    }
  }, [trains, t]);

  useEffect(() => {
    var start = trains[train_id]?.racks?.length;
    start = start ? start : 1;

    if (start > parseInt(stageNo)) {
      for (let i = start; i > parseInt(stageNo); i--) {
        trains[train_id]?.racks.pop(i - 1);
      }
    }
    for (let i = start; i <= parseInt(stageNo); i++) {
      trains[train_id].racks.push({ rack_id: i });
    }
    setTrains({ ...trains });
  }, []);

  useEffect(() => {
    var start = trains[train_id]?.racks?.length;
    start = start ? start : 1;

    if (start > stageNo) {
      for (let i = start; i > parseInt(stageNo); i--) {
        trains[train_id]?.racks.pop(i - 1);
      }
    }
    for (let i = start + 1; i <= parseInt(stageNo); i++) {
      trains[train_id].racks.push({ rack_id: i });
    }
    setTrains({ ...trains });
  }, [rack, stageNo, t]);


  useEffect(() => {
    let isValid = true;

    if (Array.isArray(trains)) {
      for (const train of trains) {
        if (train?.racks && train.racks.length > 0) {
          for (const rack of train.racks) {

            const moduleValue = rack.num_modules_per_rack;
            const moduleNumValue = moduleValue !== undefined && moduleValue !== "" ? parseFloat(moduleValue) : null;

            if (
              moduleValue === undefined ||
              moduleValue === "" ||
              moduleNumValue === null ||
              isNaN(moduleNumValue) ||
              moduleNumValue <= 0 ||
              moduleNumValue > 100
            ) {
              isValid = false;
              break;
            }


            const areaValue = rack.active_area;
            const areaNumValue = areaValue !== undefined && areaValue !== "" ? parseFloat(areaValue) : null;

            if (
              areaValue === undefined ||
              areaValue === "" ||
              areaNumValue === null ||
              isNaN(areaNumValue) ||
              areaNumValue <= 0 ||
              areaNumValue > 500
            ) {
              isValid = false;
              break;
            }
          }
        }
        if (!isValid) break;
      }
    }

    setStageValidationSucessfull(isValid);
  }, [trains, setStageValidationSucessfull]);

  const onStageChanged = (id, value) => {
    var start = trains[train_id]?.racks?.length;
    start = start ? start : 1;

    if (start > value) {
      for (let i = start; i > value; i--) {
        trains[train_id]?.racks.pop(i - 1);
      }
    }
    for (let i = start + 1; i <= parseInt(value); i++) {
      trains[train_id].racks.push({ rack_id: i });
    }

    setTrains({ ...trains });
    setRack(value);
  };

  const onStageInputChanged = (stageId, value, name) => {
    if (name === "installation_year") {
      value = value ? moment(value).format("YYYY-MM-DD") : "";
    }
    const trainId = train_id + 1;
    const trainIndex = trains.findIndex(
      (trainItem) => trainItem.train_id === trainId
    );

    if (trainIndex !== -1) {
      const previousValue = trains[trainIndex].racks[stageId][name];

      trains[trainIndex].racks[stageId] = {
        ...trains[trainIndex].racks[stageId],
        [name]: value,
      };

      if ((name === "num_modules_per_rack" || name === "active_area") &&
        (previousValue !== value)) {

        let isValid = true;

        if (name === "num_modules_per_rack") {
          const numValue = parseFloat(value);
          if (value === "" || isNaN(numValue) || numValue <= 0 || numValue > 100) {
            isValid = false;
          }
        }

        if (name === "active_area") {
          const numValue = parseFloat(value);
          if (value === "" || isNaN(numValue) || numValue <= 0 || numValue > 500) {
            isValid = false;
          }
        }

        if (!isValid) {
          setStageValidationSucessfull(false);
        } else {
          let allValid = true;

          for (const train of trains) {
            if (train.racks && train.racks.length > 0) {
              for (const rack of train.racks) {
                if (train.train_id === trainId && rack.rack_id === stageId + 1 &&
                  (name === "num_modules_per_rack" || name === "active_area")) {
                  continue;
                }

                const moduleValue = rack.num_modules_per_rack;
                const moduleNumValue = moduleValue !== undefined && moduleValue !== "" ?
                  parseFloat(moduleValue) : null;

                if (moduleValue === undefined || moduleValue === "" ||
                  moduleNumValue === null || isNaN(moduleNumValue) ||
                  moduleNumValue <= 0 || moduleNumValue > 100) {
                  allValid = false;
                  break;
                }

                const areaValue = rack.active_area;
                const areaNumValue = areaValue !== undefined && areaValue !== "" ?
                  parseFloat(areaValue) : null;

                if (areaValue === undefined || areaValue === "" ||
                  areaNumValue === null || isNaN(areaNumValue) ||
                  areaNumValue <= 0 || areaNumValue > 500) {
                  allValid = false;
                  break;
                }
              }
              if (!allValid) break;
            }
          }
          setStageValidationSucessfull(allValid);
        }
      }
    }

    setTrains({ ...trains });
    setInputVal({ ...trains });

    const totals = getTotalNumber(trains);
    setTotalNumberOfElements(totals.total_Modules);
    setTotalNumberOfActiveArea(totals.total_ActiveArea);
  };
  const getInputVal = (key, index) => {
    if (Object.keys(inputVal).length > 0 && inputVal[train_id]) {
      const id = inputVal[train_id].racks[index];
      return id && id[key] ? id[key] : "";
    } else return "";
  };

  const getTotalNumber = (trains) => {
    const stageValue = [];

    for (const train of trains) {
      for (const rack of train.racks) {
        if (
          rack.num_modules_per_rack === undefined ||
          rack.active_area === undefined
        ) {
          rack.num_modules_per_rack = 44;
          rack.active_area = 77;
          stageValue.push({
            ["num_modules_per_rack "]: rack.num_modules_per_rack,
            ["active_area"]: rack.active_area,
          });
        } else {
          stageValue.push({
            ["num_modules_per_rack"]: rack.num_modules_per_rack,
            ["active_area"]: rack.active_area,
          });
        }
      }
    }
    const total_Modules = calculateCumulativeSum(stageValue);
    const total_ActiveArea = calculateCumulativeActieAreaSum(stageValue);
    return { total_Modules, total_ActiveArea };
  };

  const calculateCumulativeSum = (data) => {
    let cumulativeSum = 0;
    for (const element of data) {
      const numPressureVessels = parseInt(element.num_modules_per_rack);
      cumulativeSum += numPressureVessels;
    }
    const sum = isNaN(cumulativeSum) ? "" : cumulativeSum;
    return sum;
  };

  const calculateCumulativeActieAreaSum = (data) => {
    let cumulativeSum = 0;
    for (const element of data) {
      const numPressureVessels = parseInt(element.num_modules_per_rack);
      const numActiveArea = parseInt(element.active_area);
      const product = numPressureVessels * numActiveArea;
      cumulativeSum += product;
    }
    const sum = isNaN(cumulativeSum) ? "" : cumulativeSum;
    return sum;
  };

  const getErrors = (key, index) => {
    if (
      !rackValidationSucessfull &&
      (trains[train_id].racks[index] === undefined ||
        trains[train_id].racks[index][key] === undefined ||
        trains[train_id].racks[index][key] === "")
    ) {
      return true;
    }
    return false;
  };

  return (
    <>
      <div className="flex-between description-text outline-box">
        <span className="description-text">
          {t("addNewPlant.noOfrack")}
          <span style={{ color: "red" }}> *</span>
        </span>
        <div className="custom-input-width">
          <SelectDropDown
            placeholder={t("addNewPlant.rack")}
            value={stageNo.toString()}
            onChange={(value) => onStageChanged(train_id, value)}
            options={rackOption}
          />
        </div>
      </div>

      <div className="section-wrapper">
        {trains[train_id].racks.length > 0 && (
          <div className="floating-icon">
            <PopoverText
              descriptor={<img src={InfoIconGreen} alt="icon" />}
              descriptionText={t("addNewPlant.systemConfigurationDescription")}
            />
          </div>
        )}

        <div className="flex-between outline-box horizontal-scroll-container">
          <div
            className="description-text marginTop30"
            style={{ minWidth: "max-content" }}
          >
            <div className="padding-top-20">
              {t("addNewPlant.noOfModules")}
              <span style={{ color: "red" }}>*</span>
            </div>
            <div className="padding-top-20">
              {t("addNewPlant.activeArea")}
              <span style={{ color: "red" }}>*</span>
            </div>
            <div className="padding-top-20">
              {t("addNewPlant.ro/nfElements")}
            </div>
            <div className="padding-top-20">
              {t("addNewPlant.installationYear")}
            </div>
          </div>

          <div className="flex-between">
            {Array.from({
              length: trains[train_id].racks.length,
            }).map((_, index) => (
              <div className="margin-left-stage stage-Input" key={index}>
                <div className="teal-text marginBtm20">
                  <span>{`${t("addNewPlant.rack")} ${index + 1}`}</span>
                </div>
                <div>
                  <InputBox
                    key={`${train_id}num_modules_per_rack${index}`}
                    name="num_modules_per_rack"
                    value={getInputVal("num_modules_per_rack", index)}
                    placeholder={t("addNewPlant.noOfModules")}
                    onChange={(value, name) =>
                      onStageInputChanged(index, value, name)
                    }
                    validator={TextFieldValidator.NUMBER_ONLY}
                    errorMsg={
                      getErrors("num_modules_per_rack", index)
                        ? t("addNewPlant.noofModulesValidation")
                        : getInputVal("num_modules_per_rack", index) !== "" &&
                          (parseFloat(
                            getInputVal("num_modules_per_rack", index)
                          ) <= 0 ||
                            parseFloat(
                              getInputVal("num_modules_per_rack", index)
                            ) > 100)
                        ? t("addNewPlant.noofModulesValidation")
                        : ""
                    }
                    maxLength={3}
                  />

                  <InputBox
                    key={`${train_id}active_area${index}`}
                    name="active_area"
                    value={getInputVal("active_area", index)}
                    placeholder={t("addNewPlant.activeArea")}
                    customClass="padding-top-10"
                    onChange={(value, name) =>
                      onStageInputChanged(index, value, name)
                    }
                    validator={TextFieldValidator.NUMBER_ONLY}
                    maxLength={3}
                    errorMsg={
                      getErrors("active_area", index)
                        ? t("addNewPlant.activeAreaValidation")
                        : getInputVal("active_area", index) !== "" &&
                          (parseFloat(getInputVal("active_area", index)) <= 0 ||
                            parseFloat(getInputVal("active_area", index)) > 500)
                        ? t("addNewPlant.activeAreaValidation")
                        : ""
                    }
                  />

                  <InputBox
                    key={`${train_id}modules_used${index}`}
                    name="modules_used"
                    value={getInputVal("modules_used", index)}
                    customClass="padding-top-10"
                    placeholder={t("addNewPlant.ro/nfElements")}
                    validator={TextFieldValidator.ALPHANUMERIC_WITH_CHINESE}
                    onChange={(value, name) =>
                      onStageInputChanged(index, value, name)
                    }
                  />
                  <div className="padding-top-10">
                    <DupontDatePicker
                      id={`${train_id}installation_year${index}`}
                      selected={
                        getInputVal("installation_year", index) !== ""
                          ? new Date(getInputVal("installation_year", index))
                          : ""
                      }
                      dateFormat={t("ValueStrings.DATE_FORMAT_SMALL")}
                      onChange={(value, name) =>
                        onStageInputChanged(index, value, "installation_year")
                      }
                      startDate={new Date()}
                      maxDate={new Date()}
                      className={"width-fill "}
                      {...DatePickerConfig}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};
